import React, { useEffect, useState } from 'react';
import Sidemenu from '../base/sidemenu';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchQnaDetail, postQnaReply } from '../../services/AdminQnaService';
import './AdminQnaDetail.css';

export default function AdminQnaDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [qnaDetail, setQnaDetail] = useState(null);
  const [reply, setReply] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    let active = true;

    const getDetail = async () => {
      try {
        const token = localStorage.getItem('token');
        const data = await fetchQnaDetail(id, token);

        if (!data.success) throw new Error(data.message || '상세 조회 실패');

        if (active) {
          setQnaDetail({
            ...data.qna_detail,
            replies: Array.isArray(data.replies) ? data.replies : []
          });
        }
      } catch (err) {
        console.error('문의사항 상세 조회 실패:', err);
        if (active) setError(true);
      } finally {
        if (active) setLoading(false);
      }
    };

    getDetail();
    return () => { active = false; };
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reply.trim() || submitting) return;

    setSubmitting(true);
    try {
      const token = localStorage.getItem('token');
      const data = await postQnaReply(Number(id), reply.trim(), token);

      if (!data.success) throw new Error(data.message || '답변 등록 실패');

      const refreshed = await fetchQnaDetail(id, token);
      if (refreshed.success) {
        setQnaDetail({
          ...refreshed.qna_detail,
          replies: Array.isArray(refreshed.replies) ? refreshed.replies : []
        });
      } else {
        throw new Error('답변 등록 후 상세 정보 갱신 실패');
      }

      setReply('');
      alert('답변이 등록되었습니다.');
    } catch (err) {
      console.error('답변 처리 실패:', err);
      alert('답변 처리 중 오류가 발생했습니다. 목록을 새로고침해 확인해 주세요.');
    } finally {
      setSubmitting(false);
    }
  };

  const formatDate = (value) =>
    value ? new Date(value).toLocaleString('ko-KR') : '-';

  return (
    <div className="flex qd-layout">
      <Sidemenu />
      <main className="qd-content">
        <div className="qd-heading">
          <div>
            <h2>문의사항 상세보기</h2>
            <p>사용자 문의 내용 및 답변 관리</p>
          </div>
          <button type="button" className="qd-back"
            onClick={() => navigate('/adminqna')}>
            목록으로
          </button>
        </div>

        {loading ? (
          <div className="qd-panel qd-message">문의 정보를 불러오는 중입니다.</div>
        ) : error || !qnaDetail ? (
          <div className="qd-panel qd-message">
            문의사항을 불러오지 못했습니다.
            <div className="qd-error-actions">
              <button type="button" onClick={() => navigate('/adminqna')}>
                목록으로
              </button>
            </div>
          </div>
        ) : (
          <div className="qd-panel">
            <div className="qd-question-header">
              <div className="qd-question-title">{qnaDetail.title}</div>
              <div className="qd-meta">
                <span><strong>작성자</strong> {qnaDetail.name || '알 수 없음'}</span>
                <span><strong>작성일</strong> {formatDate(qnaDetail.create_date)}</span>
              </div>
            </div>

            <section className="qd-section">
              <h3>문의 내용</h3>
              <div className="qd-question-body">{qnaDetail.content || '-'}</div>
            </section>

            <section className="qd-section">
              <div className="qd-section-title">
                <h3>답변 목록</h3>
                <span className="qd-count">{qnaDetail.replies.length}건</span>
              </div>

              {qnaDetail.replies.length > 0 ? (
                <div className="qd-replies">
                  {qnaDetail.replies.map((r) => (
                    <div className="qd-reply" key={r.id}>
                      <div className="qd-reply-header">
                        <strong>{r.user_name || '관리자'}</strong>
                        <span>{formatDate(r.create_date)}</span>
                      </div>
                      <div className="qd-reply-body">{r.content}</div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="qd-no-reply">등록된 답변이 없습니다.</div>
              )}
            </section>

            <section className="qd-section">
              <h3>답변 작성</h3>
              <form onSubmit={handleSubmit}>
                <textarea
                  value={reply}
                  onChange={(e) => setReply(e.target.value)}
                  placeholder="답변 내용을 입력하세요."
                  rows={5}
                  required
                  disabled={submitting}
                />
                <div className="qd-actions">
                  <button type="button" className="qd-back"
                    onClick={() => navigate('/adminqna')}>
                    목록으로
                  </button>
                  <button type="submit" className="qd-submit"
                    disabled={submitting || !reply.trim()}>
                    {submitting ? '등록 중...' : '답변 등록'}
                  </button>
                </div>
              </form>
            </section>
          </div>
        )}
      </main>
    </div>
  );
}
